export const CREATE_COMPANY_GROUP = "CREATE_COMPANY_GROUP";
export const FETCH_COMPANY_GROUP = "FETCH_COMPANY_GROUP";
export const EDIT_COMPANY_GROUP = "EDIT_COMPANY_GROUP";
